module.exports = __webpack_public_path__ + "images/sound_on_cd4b193382bd6fb45fcf86c0ae0afed3.png";